import { FILE_CONFIG } from '../../config/files';

export const getBaseImage = (imageUrl: string) => imageUrl.startsWith('http://') || imageUrl.startsWith('https://') ? imageUrl : FILE_CONFIG.BASE_URL + imageUrl;
